import React, { ReactNode, useCallback } from 'react';
import Modal from 'react-modal';

import './index.css';

export type CenterModalProps = {
  isOpen?: boolean;
  onRequestClose?(): void;
  children?: ReactNode;
} & Omit<Modal.Props, 'isOpen' | 'onRequestClose'>;

export const CenterModal = ({
  isOpen = true,
  onRequestClose,
  children,
  ...rest
}: CenterModalProps) => {
  const handleClick = useCallback(e => {
    e.stopPropagation();
  }, []);

  return (
    // 不加 div，总是会穿透
    <div onClick={handleClick} className="db-centerModal-wrap">
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        ariaHideApp={false}
        shouldReturnFocusAfterClose={false}
        shouldFocusAfterRender={false}
        {...rest}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(var(--color-black-rgba), 0.4)',
            zIndex: 1000,
            // https://github.com/reactjs/react-modal/issues/188
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...rest.style?.overlay,
          },
          content: {
            position: 'static',
            border: 0,
            padding: 0,
            borderRadius: 0,
            WebkitOverflowScrolling: 'touch',
            boxShadow: '0 3px 8px 0 rgba(var(--color-black-rgba),0.05)',
            overflow: 'auto',
            backgroundColor: 'transparent',
            ...rest.style?.content,
          },
        }}>
        <div className="db-centerModal-body">{children}</div>
      </Modal>
    </div>
  );
};

export default CenterModal;
